export const dateTimeFormats = {
  'en-US': {
    dateAndTime: {
      // Jan. 15, 2019, 1:00 p.m.
      hour: 'numeric',
      minute: 'numeric',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    },
    time: {
      // Jan. 15, 2019, 1:00 p.m.
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'en-CA': {
    dateAndTime: {
      // Jan. 15, 2019, 1:00 p.m.
      hour: 'numeric',
      minute: 'numeric',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    },
    time: {
      // Jan. 15, 2019, 1:00 p.m.
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'fr-CA': {
    dateAndTime: {
      // Jan. 15, 2019, 1:00 p.m.
      hour: 'numeric',
      minute: 'numeric',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    },
    time: {
      // Jan. 15, 2019, 1:00 p.m.
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'es-MX': {
    dateAndTime: {
      // Jan. 15, 2019, 1:00 p.m.
      hour: 'numeric',
      minute: 'numeric',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    },
    time: {
      // Jan. 15, 2019, 1:00 p.m.
      hour: 'numeric',
      minute: 'numeric'
    }
  }
}

const enCA = {
  // expired
  sorry: 'A change has been made to your Repair Order and this link is no longer active. Check your messages for an updated link, or contact your service advisor if you have any questions.',
  // header
  inspection: 'Inspection',
  items: 'Item | Items',
  additional_items: 'Additional Item | Additional Items',
  review_items: 'View Item | View Items',
  help: 'Help',
  services_approved: 'Services Approved',
  how_it_works: 'How It Works',
  // login
  header_first_half: 'Vehicle Inspection Update',
  header_second_half: '',
  enter: 'Enter',
  please_enter_your_last_name: 'Please enter your last name',
  please_enter_your_company_name: 'Please enter your company name',
  // drawer
  information: 'Information',
  call_service_advisor: 'Call Service Advisor',
  text_service_advisor: 'Text Service Advisor',
  view_inspection_report: 'View Inspection Report',
  // tutorial
  review: 'Review',
  approve: 'Approve',
  decline: 'Decline',
  checkBoxHeading: 'Please make a decision for each recommendation.',
  pickup: 'Pick Up',
  description1: 'Review the (pre-selected) new items that we have found.',
  description2: 'Approve the items so that we can begin the repairs.',
  description3: 'Pick up your vehicle when your service advisor contacts you.',
  next: 'Next',
  skip: 'Skip',
  // glance
  you_have: 'You have',
  your_service_advisor: 'Your Service Advisor',
  that_need_your_attention: 'that needs your attention. | that need your attention.',
  select_your_services_in: 'Select your services in:',
  to_have_your_vehicle_ready_by: 'to have your vehicle ready by:',
  thank_You_for_chosing: 'Thank you for choosing',
  for_your_service_need:  'for your service needs.',
  your_vehicle_inspected: "Your vehicle has been inspected and everything looks good!",
  today: 'Today',
  inpection_Level_Media_Heading: 'The following media is attached to your inspection. Select the image to open it.',
  at: 'at',
  // inspection
  total_estimate: 'Total Estimate',
  updated: 'Updated',
  free: 'Free',
  confirm: 'Confirm',
  no_issue_found: 'No issue was found.  Please see comments for more information.',
  problem_identified: 'Problem has been identified. Please see comments for more information.',
  // service
  total: 'Total',
  back: 'Back',
  not_today: 'Not today',
  advisor_comments: 'Advisor comments',
  Warranty: 'Please note this service is covered under Warranty - you will NOT be charged for it',
  Internal: 'Please note this service is free - you will NOT be charged for it',
  ServiceContract: 'Please note the price of this service is covered by the service contract - you will NOT be charged for it',
  Free: 'Please note this service is free - you will NOT be charged for it',
  Included: 'Please note the price of this service is included - you will NOT be charged for it',
  // reason
  please_select_a_reason: 'Please select a reason for deferring this service',
  // summary
  service_summary: 'Service Summary',
  services_approved_at_dealership: 'Items you approved when you checked into the dealership',
  previously_approved_items: 'Previously approved items',
  taxes_and_fees_included: 'TAXES AND FEES INCLUDED',
  estimate: 'Estimate for selected services',
  core_charge: 'Core charge',
  core_return_credit: 'Core return credit',
  additional_taxes_and_fees: 'Additional Taxes and Fees',
  hazardous_materials_fee: 'Hazardous Materials Fee',
  newly_approved_items: 'Newly approved items',
  total_cost: 'Total Cost',
  total_cost_no_surcharge: 'Debit card or cash price',
  total_cost_with_surcharge: 'Credit card price',
  disclaimer: 'Disclaimer',
  total_updated_cost: 'Total Updated Cost',
  please_sign_below: 'Please sign below',
  completed_via_advisor: 'Completed via Advisor',
  clear: 'Clear',
  click_to_sign: 'Click to sign',
  i_acknowledge: 'I acknowledge the agreement of the Dealership’s',
  terms_and_conditions: 'Terms and Conditions',
  please_sign_in_and_accept: 'Please sign and accept Terms and Conditions to continue',
  // terms_and_conditions
  paragraph1: 'All warranties on the parts and accessories sold hereby are made by the manufacturer. The undersigned purchaser understand and agrees that dealer makes no warranties of any kind, express or implied, and disclaims all warranties, including warranties of merchantability or fitness for a particular purpose; and that in no event shall dealer be liable for incidental or consequential damages or commercial losses arising out of such purchase. The undersighed purchaser further agrees that the warranties excluded by the dealer, include, but are not limited to any warranties that such parts and/or accessories are of merchantable quality or that they will enable any vehicle or any of its systems to perform with reasonable safety, efficiency, or comfort.',
  paragraph2: 'I hereby authorize the repair work herein set forth to be done along with the necessary material and agree that you are not responsible for loss or damage to vehicle or articles left in vehicle in case of fire, theft, or any cause beyond your control or for any delays caused by unavailability of parts or delays in parts shipments by the supplier or transporter. I hereby grant you and/or your employees permission to operate the behicle herein described on streets, highways, or elsewhere for the purpose of testing and/or inspection. An express mechanical lien is hereby acknowledged on above vehicle to secure the amount of repairs thereto. The dealership is not responsible for damages from freezing due to lack of antifreeze.',
  accept: 'Accept',
  decline: 'Decline',
  // thanks
  thank_you: 'Thank you for your time!',
  ready: 'Your vehicle will be ready by',
  your_service_advisor_will_confirm: 'Your Service Advisor will confirm with you when your vehicle is ready.',
  // not_found
  go_back: 'Go Back',
  log_in: 'Log In',
  // help
  tap_each_category: 'Tap each category to review items',
  approve_items: 'Approve Items',
  tap_the_checkbox: 'Tap the checkbox to approve the new item',
  view_more_details: 'View More Details',
  tap_on_the_images: 'Tap on the images to view more information about the item',
  approve_estimate: 'Approve Estimate',
  continue_to_checkout: 'Continue to checkout after approving your service summary',
  more_help: 'More Help',
  to_get_more_help: 'To get more help, click the menu button',
  got_it: 'Got it',
  dismiss: 'Dismiss',
  // error
  error: 'Error',
  something_went_wrong: 'We\'re sorry, something went wrong',
  were_sorry_we_dont_recognize: 'We\'re sorry but we don\'t recognize',
  in_our_database: 'in our database.',
  we_couldnt_get_tax: 'We couldn\'t get the taxes and fees',
  call_us_at: 'Call us at',
  try_again: 'Try again',
  // wait
  wait_there_are: 'Wait, there are still',
  wait_there_is: 'Wait, there is still',
  pending_approval: 'pending approval',
  // not supported
  your_browser_is_not_supported: 'Your browser is not supported.',
  please_use: 'Please use a current version of one of Chrome, Edge or Firefox.',
  your_version_of_ios: 'Your version of iOS is not supported.',
  use_a_current_version_of_ios: 'Please use a current version of iOS.',
  inspection_Report: 'Inspection Report',
  viewDetails: 'VIEW DETAILS',
  mediaAttached: 'media attached',
  sublet: 'Sublet'
}
const frCA = {
  // expired
  sorry: 'Une modification a été apportée à votre ordre de réparation et ce lien n\'est plus actif. Vérifiez vos messages pour obtenir un lien mis à jour, ou contactez votre conseiller de service si vous avez des questions.',
  // header
  inspection: 'Inspection',
  items: 'Élément | Éléments',
  additional_items: 'Élément supplémentaire | Éléments supplémentaires',
  review_items: 'Voir élément | Voir éléments',
  help: 'Aide',
  services_approved: 'Services Précédemment Approuvés',
  how_it_works: 'Comment cela fonctionne-t-il?',
  // login
  header_first_half: 'Résultats d\'inspection',
  header_second_half: '',
  enter: 'Soumettre',
  please_enter_your_last_name: 'Veuillez inscrire votre nom de famille',
  please_enter_your_company_name: 'Veuillez inscrire le nom de votre compagnie',
  // drawer
  information: 'Information',
  call_service_advisor: 'Appeler le conseiller au service',
  text_service_advisor: 'Envoyer un texto au conseiller au service',
  view_inspection_report: 'Visionner le rapport d’inspection',
  // tutorial
  review: 'Examiner',
  approve: 'Approuver',
  decline: 'Refuser',
  
  pickup: 'Ramassage',
  checkBoxHeading: 'Veuillez prendre une décision pour chaque recommandation.',
  description1: 'Examinez les nouveaux éléments (présélectionnés) que nous avons trouvés.',
  description2: 'Approuver les éléments afin que nous puissions commencer les réparations.',
  description3: 'Venez chercher votre véhicule lorsque votre conseiller au service vous contacte.',
  next: 'Suivant',
  skip: 'Passer',
  // glance
  you_have: 'Vous avez',
  your_service_advisor: 'Votre conseiller au service',
  that_need_your_attention: 'requérant votre attention.',
  select_your_services_in: 'Sélectionnez vos services dans:',
  to_have_your_vehicle_ready_by: 'pour que votre véhicule soit prêt au plus tard à:',
  thank_You_for_chosing: ' Nous vous remercions d’avoir choisi',
  for_your_service_need:  'pour effectuer l’entretien de votre véhicule.',
  your_vehicle_inspected: "Nous avons fait l’inspection de votre véhicule et tout est beau!",
  today: 'Aujourd\'hui',
  at: 'à',
  inpection_Level_Media_Heading: 'Le média suivant est joint à votre inspection. Veuillez sélectionner l’image pour le visionner.',
  // inspection
  total_estimate: 'Total du devis',
  updated: 'mise à jour',
  free: 'Gratuit',
  confirm: 'Confirmer',
  no_issue_found: 'Aucun problème trouvé. Veuillez voir les commentaires pour en savoir plus.',
  problem_identified: 'Un problème a été trouvé. Veuillez voir les commentaires pour en savoir plus.',
  // service
  total: 'Total',
  back: 'Retour',
  not_today: 'Pas aujourd’hui',
  advisor_comments: 'Commentaires du conseiller',
  Warranty: 'Veuillez noter que ce service est couvert par la garantie, il ne vous sera PAS facturé',
  Internal: 'Veuillez noter que ce service est gratuit, il ne vous sera PAS facturé',
  ServiceContract: 'Veuillez noter que le coût de ce service est couvert par votre contrat de service. Il ne vous sera donc PAS facturé',
  Free: 'Veuillez noter que ce service est gratuit, il ne vous sera PAS facturé',
  Included: 'Veuillez noter que le prix de ce service est inclus, il ne vous sera PAS facturé',
  // reason
  please_select_a_reason: 'Veuillez indiquer la raison pour laquelle vous souhaitez différer ce service',
  // summary
  service_summary: 'Récapitulatif de l\'entretien',
  services_approved_at_dealership: 'Éléments que vous avez approuvés à votre arrivée à la concession',
  previously_approved_items: 'Éléments précédemment approuvés',
  taxes_and_fees_included: 'TAXES ET FRAIS INCLUS',
  estimate: 'Coût estimatif pour les services sélectionnés',
  core_charge: 'Core charge',
  core_return_credit: 'Core return credit',
  additional_taxes_and_fees: 'Taxes et frais supplémentaires',
  hazardous_materials_fee: 'Frais de matières dangereuses',
  newly_approved_items: 'Éléments nouvellement approuvés',
  total_cost: 'Coût total',
  total_cost_no_surcharge: 'Prix (carte de débit ou comptant)',
  total_cost_with_surcharge: 'Prix (carte de crédit)',
  disclaimer: 'Avis De Non-Responsabilité',
  total_updated_cost: 'Coût total actualisé',
  please_sign_below: 'Signez ici',
  clear: 'Effacer',
  click_to_sign: 'Veuillez cliquer pour signer',
  i_acknowledge: 'J’accepte les modalités et les conditions de la concession',
  terms_and_conditions: 'Conditions Générales',
  please_sign_in_and_accept: 'Veuillez signer et accepter les modalités et les conditions pour continuer',
  // terms_and_conditions
  paragraph1: 'Toutes les garanties sur les pièces et accessoires vendus par la présente sont faites par le constructeur. L’acheteur soussigné comprend et accepte que la concession ne fait aucune garantie d’aucune sorte, explicite ou implicite, et se dégage de toute responsabilité quant à toute garantie, y compris la garantie de qualité marchande ou la garantie de capacité du produit à accomplir un but précis; et que la concession ne saurait, en aucun cas, être tenue pour responsable de tout dommage accessoire ou immatériel, ou de toute perte commerciale résultant de cet achat. L’acheteur soussigné accepte également que les garanties exclues par la concession incluent, sans s’y limiter, toute garantie que lesdites pièces et/ou lesdits accessoires auront une quelconque qualité marchande ou qu’ils permettront à un quelconque véhicule ou système de fonctionner avec une sécurité, une efficacité ou un confort raisonnable.',
  paragraph2: 'J’autorise, par la présente, la réalisation du travail de réparation décrit par la présente et l’utilisation de tout matériel nécessaire. J’accepte également que la concession n’assume aucune responsabilité pour la perte ou les dommages causés au véhicule ou aux articles laissés dans le véhicule en cas d’incendie, de vol ou de toute autre raison en dehors du contrôle de la concession, et que la concession ne saurait être tenue pour responsable des retards causés par l’indisponibilité des pièces ou les retards d’expédition des pièces par le fournisseur ou le transporteur. Je donne, par la présente, l’autorisation à la concession et/ou à ses employés de conduire le véhicule décrit dans la présente sur les routes, les autoroutes et ailleurs, dans le but de réaliser des tests et/ou une inspection. La présente reconnaît expressément un droit de rétention mécanique pour le véhicule ci-dessus, dans le but de réaliser la quantité des réparations décrites. La concession ne saurait être tenue comme responsable des dommages causés par le gel résultant d’une quantité insuffisante d’antigel.',
  accept: 'Accepter',
  decline: 'Refuser',
  // thanks
  thank_you: 'Nous vous remercions d’avoir pris le temps de répondre.',
  ready: 'Votre véhicule sera prêt à',
  your_service_advisor_will_confirm: 'Votre conseiller au service vous notifiera lorsque votre véhicule sera prêt.',
  // not_found: {
  go_back: 'Retour',
  log_in: 'S’identifier',
  // help
  tap_each_category: 'Appuyez sur chaque catégorie pour examiner les éléments',
  approve_items: 'Approuver les éléments',
  tap_the_checkbox: 'Cocher la case pour approuver le nouvel élément',
  view_more_details: 'Voir plus de détails',
  tap_on_the_images: 'Appuyez sur les images pour afficher plus d\'informations à propos de l\'élément.',
  approve_estimate: 'Approuver le devis',
  continue_to_checkout: 'Poursuivez vers le paiement après avoir approuvé le sommaire de service',
  more_help: 'Aide supplémentaire',
  to_get_more_help: 'Pour obtenir de l’aide supplémentaire, veuillez cliquer sur le bouton du menu',
  got_it: 'J’ai compris',
  dismiss: 'Ignorer',
  // error
  error: 'Erreur',
  something_went_wrong: 'Nous sommes désolés, une erreur s’est produite',
  were_sorry_we_dont_recognize: 'Désolé mais le nom',
  in_our_database: 'est non reconnu dans notre système.',
  we_couldnt_get_tax: 'Nous n’avons pas pu obtenir le montant des taxes et des frais',
  call_us_at: 'Veuillez nous contacter au',
  try_again: 'Réessayer',
  // wait
  wait_there_are: 'Attendez, il vous reste encore',
  wait_there_is: 'Attendez, il vous reste encore',
  pending_approval: 'à approuver',
  // not supported
  your_browser_is_not_supported: 'Votre navigateur Web n\'est pas pris en charge.',
  please_use: 'Veuillez utiliser une version actuelle de Chrome, Edge ou Firefox.',
  your_version_of_ios: 'Votre version d\'iOS n\'est pas prise en charge.',
  use_a_current_version_of_ios: 'Veuillez utiliser une version actuelle d\'iOS.',
  inspection_Report: "Rapport d'inspection",
  viewDetails: 'VOIR LES DÉTAILS',
  mediaAttached: 'media attached',
  sublet: 'Sublet'
}
const esMX = {
  // expired
  sorry: 'Se ha realizado un cambio en su orden de reparación y este enlace ya no está activo. Revise sus mensajes para obtener un enlace actualizado, o comuníquese con su asesor de servicio si tiene alguna pregunta.',
  // header
  inspection: 'Inspección',
  items: 'Ítem | Ítems',
  additional_items: 'Ítem Adicional | Ítems Adicionales',
  review_items: 'Ver Ítem | Ver Ítems',
  help: 'Ayuda',
  services_approved: 'Servicios Aprobados Previamente',
  how_it_works: 'Cómo funciona',
  // login
  header_first_half: 'Actualización de inspección',
  header_second_half: 'del vehículo',
  enter: 'Introducir',
  please_enter_your_last_name: 'Por favor ingrese su apellido',
  please_enter_your_company_name: 'Por favor ingrese el nombre de su compañia',
  // drawer
  information: 'Información',
  call_service_advisor: 'Llamar al Asesor de Servicio',
  text_service_advisor: 'Enviar mensaje al Asesor de Servicio',
  view_inspection_report: 'Ver el informe de inspección',
  // tutorial
  review: 'Revisión',
  approve: 'Aprobar',
  decline: 'Rechazar',
  
  checkBoxHeading: 'Por favor tome una decisión para cada recomendación.',
  pickup: 'Retirar',
  description1: 'Revisar los nuevos ítems (pre-seleccionados) encontrados.',
  description2: 'Aprobar los ítems para empezar las reparaciones.',
  description3: 'Retire su vehículo cuando su Asesor de Servicio lo contacte.',
  next: 'Siguiente',
  skip: 'Omitir',
  inpection_Level_Media_Heading: 'Se adjuntan a esta inspección los siguientes archivos multimedia. Seleccione la imagen para abrirla.',
  // glance
  you_have: 'Tiene',
  your_service_advisor: 'Su Asesor de Servicio',
  that_need_your_attention: 'que requiere su atención.',
  select_your_services_in: 'Seleccione sus servicios en:',
  to_have_your_vehicle_ready_by: 'para tener su vehículo listo el:',
  thank_You_for_chosing: ' Gracias por preferir a',
  for_your_service_need:  'para atender sus necesidades de servicio.',
  your_vehicle_inspected: "¡Su vehículo ha sido inspeccionado y todo se ve bien!",
  today: 'Hoy',
  at: 'a las',
  // inspection
  total_estimate: 'Total presupuesto',
  updated: 'Actualizada',
  free: 'Gratis',
  confirm: 'Confirmar',
  no_issue_found: 'No se encontró ningún problema. Vea los comentarios para obtener más información.',
  problem_identified: 'No se encontró ningún problema. Vea los comentarios para obtener más información.',
  // service
  total: 'Total',
  back: 'Atrás',
  not_today: 'Hoy no',
  advisor_comments: 'Comentarios del asesor',
  Warranty: 'Tenga en cuenta que este servicio está cubierto por la garantía, NO se le cobrará por él',
  Internal: 'Tenga en cuenta que este servicio es gratuito, NO se le cobrará por él',
  ServiceContract: 'Tenga en cuenta que el precio de este servicio está cubierto por el contrato de servicio; a usted NO se le cobrará por él',
  Free: 'Tenga en cuenta que este servicio es gratuito, NO se le cobrará por él',
  Included: 'Tenga en cuenta que el precio de este servicio está incluido, NO se le cobrará por separado',
  // reason
  please_select_a_reason: 'Seleccione un motivo para diferir este servicio',
  // summary
  service_summary: 'Resumen del servicio',
  services_approved_at_dealership: 'Ítems que usted aprobó cuando llegó al local del concesionario',
  previously_approved_items: 'Ítems previamente aprobados',
  taxes_and_fees_included: 'IMPUESTOS Y TASAS INCLUIDOS',
  estimate: 'Presupuesto por servicios seleccionados',
  core_charge: 'Core charge',
  core_return_credit: 'Core return credit',
  additional_taxes_and_fees: 'Impuestos y cargos adicionales',
  hazardous_materials_fee: 'Cargo por materiales peligrosos',
  newly_approved_items: 'Ítems recientemente aprobados',
  total_cost: 'Costo total',
  total_cost_no_surcharge: 'Precio (tarjeta de débito o efectivo)',
  total_cost_with_surcharge: 'Precio (tarjeta de crédito)',
  disclaimer: 'Aviso Legal',
  total_updated_cost: 'Costo total actualizado',
  please_sign_below: 'Firme a continuación',
  clear: 'Borrar',
  click_to_sign: 'Haga clic para firmar',
  i_acknowledge: 'Confirmo la aceptación de los Términos y Condiciones del concesionario',
  terms_and_conditions: 'Terminos y condiciones',
  please_sign_in_and_accept: 'Por favor, firme y acepte los Términos y Condiciones para continuar',
  // terms_and_conditions
  paragraph1: 'Todas las garantías sobre las piezas y accesorios vendidos aquí son ofrecidas por el fabricante. El comprador abajo firmante entiende y acepta que el concesionario no ofrece garantías de ningún tipo, expresas o implícitas, y rechaza todas las garantías, incluidas las garantías de comerciabilidad o idoneidad para un propósito en particular, y que en ningún caso el concesionario será responsable por daños incidentales o consecuentes o pérdidas comerciales derivadas de dicha compra. El comprador abajo firmante acepta además que las garantías excluidas por el concesionario, incluyen, pero no se limitan a ninguna garantía de que dichas piezas y/o accesorios son de calidad comercializable o que permitirán que cualquier vehículo o cualquiera de sus sistemas funcionen con seguridad, eficiencia y comodidad razonables.',
  paragraph2: 'Autorizo los trabajos de reparación establecidos aquí para que se realicen junto con el material necesario y acepta que ustedes no son responsables por la pérdida o daños al vehículo o artículos dejados en el vehículo en caso de incendio, robo o cualquier otra causa fuera de su control o por cualquier retraso causado por la no disponibilidad de piezas o demoras en los envíos de piezas por parte del proveedor o el transportista. Por el presente documento autorizo a usted y/o sus empleados para que conduzcan el vehículo aquí descrito en calles, carreteras, o en otros lugares con el fin de realizar pruebas y/o inspección. Se confirma aquí que se constituye prenda mecánica explícita sobre el vehículo para asegurar la cantidad de reparaciones correspondientes. El concesionario no se hace responsable de los daños por congelación debido a la falta de anticongelante.',
  accept: 'Aceptar',
  decline: 'Rechazar',
  // thanks
  thank_you: 'Gracias por su tiempo.',
  ready: 'Su vehículo estará listo a las',
  your_service_advisor_will_confirm: 'Su Asesor de Servicio confirmará con usted cuando su vehículo esté listo.',
  // not_found:
  go_back: 'Volver atrás',
  log_in: 'Iniciar sesión',
  // help
  tap_each_category: 'Seleccionar cada categoría para revisar ítems',
  approve_items: 'Aprobar ítems',
  tap_the_checkbox: 'Seleccionar el recuadro para aprobar un nuevo ítem',
  view_more_details: 'Ver más detalles',
  tap_on_the_images: 'Seleccionar las imágenes para ver información adicional del ítem',
  approve_estimate: 'Aprobar el presupuesto',
  continue_to_checkout: 'Continuar con el pedido después de aprobar el resumen de servicios',
  more_help: 'Más ayuda',
  to_get_more_help: 'Para obtener más ayuda, haga clic en el botón Menú',
  got_it: 'Comprendo',
  dismiss: 'Descartar',
  // error
  error: 'Error',
  something_went_wrong: 'Lo sentimos, algo salió mal',
  were_sorry_we_dont_recognize: 'Lo sentimos, pero no reconocemos',
  in_our_database: 'en nuestra base de datos.',
  we_couldnt_get_tax: 'No pudimos obtener los impuestos y cargos',
  call_us_at: 'Llámenos al',
  try_again: 'Vuelva a intentarlo',
  // wait
  wait_there_are: 'Espere, todavía hay',
  wait_there_is: 'Espere, todavía hay',
  pending_approval: 'pendientes de aprobación',
  // not supported
  your_browser_is_not_supported: 'Tu navegador web no es compatible.',
  please_use: 'Utilice una versión actual de Chrome, Edge o Firefox.',
  your_version_of_ios: 'Su versión de iOS no es compatible.',
  use_a_current_version_of_ios: 'Utiliza una versión actual de iOS.',
  inspection_Report: 'Informe de inspección',
  viewDetails: 'VER DETALLES',
  mediaAttached: 'media attached',
  sublet: 'Sublet'
}

export const messages = {
  'en-US': enCA,
  'en-CA': enCA,
  'fr-CA': frCA,
  'es-MX': esMX
}
